import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';
import styles from '../../styles/OurBoxes.module.css';
import { type BoxData } from '../../lib/types';

export function BoxCard(props: {
  readonly children?: React.ReactNode;
  readonly isSmall?: boolean;
  readonly box: BoxData;
  readonly onClick: () => void;
}) {
  const { box, isSmall, children, onClick } = props;
  const ageGroupTitle = box.ageGroup ? ` • ${box.ageGroup.minMonths}M+` : '';
  const imageSize = 211;
  return (
    <Card className={`${styles.boxCard} clickable`} onClick={onClick}>
      <Card.Body className={styles.boxCardBody}>
        <Card.Img
          variant="top"
          src={box.overviewImage}
          width={imageSize}
          height={imageSize}
          as={Image}
        />
        <div className={styles.boxCardContent}>
          <div className={styles.boxCardContentText}>
            <Card.Title className={`h5 ${isSmall && 'h6 text-center'} mt-3`}>
              {box.title}
              {ageGroupTitle}
            </Card.Title>
            {!isSmall && (
              <Card.Text className={styles.boxCardBenefitsText}>
                {(box.benefitTags ?? []).join(', ')}
              </Card.Text>
            )}
          </div>
          {!isSmall && (
            <div className={styles.boxCardContentArrow}>
              <FontAwesomeIcon icon={faArrowRight} size="2x" />
            </div>
          )}
        </div>
        {children}
      </Card.Body>
    </Card>
  );
}
